import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { PaymentScenarionActionMethodEnum } from '@zaoblako/shared/modules/task/enum/payment.scenarion.action.method.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link PaymentScenarionActionMethodEnum} enumeration values */
export const PaymentScenarionActionMethodEnumI18n: EnumI18nInterface<PaymentScenarionActionMethodEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [PaymentScenarionActionMethodEnum.ADD_APPROVER]: 'Добавить новых согласователей в заявку',
    [PaymentScenarionActionMethodEnum.ADD_AUDITOR]: 'Добавить новых аудиторов в заявку',
  },
  [I18nLocalesEnum.EN_US]: {
    [PaymentScenarionActionMethodEnum.ADD_APPROVER]: 'Add new approvers in brs task',
    [PaymentScenarionActionMethodEnum.ADD_AUDITOR]: 'Add new approvers in brs task',
  },
};
